"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_1 = require("@icr-ui/icons");
const components_1 = require("../../components");
const RenderIcon = ({ value }) => {
    switch (value) {
        case components_1.Environment.PENSION_FUND_COCKPIT:
            return (0, jsx_runtime_1.jsx)(icons_1.PensionsKassenIcon, {});
        case components_1.Environment.EMPLOYER_PORTAL:
            return (0, jsx_runtime_1.jsx)(icons_1.ArbeitgeberIcon, {});
        case components_1.Environment.USER_MANAGEMENT:
            return (0, jsx_runtime_1.jsx)(icons_1.AccountIcon, {});
        default:
            return (0, jsx_runtime_1.jsx)(icons_1.AccountIcon, {});
    }
};
exports.RenderIcon = RenderIcon;
//# sourceMappingURL=utils.js.map